export default "__VITE_ASSET__w0ovNqJO__"